import { AgendaViewPageBase } from './AgendaViewPage.base';
import {
    AgendaViewPageProps,
    AgendaViewPageStyleProps,
    AgendaViewPageStyles,
} from './AgendaViewPage.types';
import { styled } from '@fluentui/react/lib/Utilities';

export { AgendaViewPageProps };

/** The default style of AgendaViewPage */
export function getStyles(styleProps: AgendaViewPageStyleProps): AgendaViewPageStyles {
    return {
        root: [
            'ms-AgendaViewPage',
            styleProps.className,
            {
                display: 'flex',
                height: 'auto',
                padding: 10,
                selectors: {
                    '#calendarPrintableItem &': {
                        height: 1130,
                    },
                },
            },
        ],
        eventsContainer: styleProps.preview && {
            height: 'auto',
            position: 'relative',
        },
        inputBlocker: {
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 99,
        },
        dateHeader: {
            fontSize: 23,
            fontWeight: 600,
            margin: '32px 0 30px 0',
        },
    };
}

/** The default styled version of AgendaViewPage */
export const AgendaViewPage = styled<
    AgendaViewPageProps<{}>,
    AgendaViewPageStyleProps,
    AgendaViewPageStyles
>(AgendaViewPageBase, getStyles) as typeof AgendaViewPageBase;
